// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__F2wSF","header":"MergedInvoice_header__1SJaZ"};